module.exports = __webpack_public_path__ + "img/discord-circle-light.9b8d2bf.svg";